import { captureMessage } from './sentry'
import { reportError } from './reportError'

// logError logs the error to console and reports it. The console call is a breadcrumb only:
// Faro records it as a log, so the report below is what reaches the Errors view.
export const logError = (error, shouldCaptureException = true, customErrorMessage = '') => {
	console.error(customErrorMessage, error)
	if (shouldCaptureException) reportError(error, { source: 'manual' })
}

// logMessage logs a message as error and publishes it to sentry as custom message
export const logMessage = (customMessage: string, data = {}) => {
	console.error(customMessage, data)
	captureMessage(customMessage, { extra: data })
}
